import type { GroupId } from './model';

/**
 * A group's page address (`/past-videos/$setId`): which check is on view (`run`, a check again's id; none: the first
 * check), the check it is compared with (`against`), the video open in the side panel (`video`), the view
 * (`view=points`; none: the videos) and the figure the page opens on (`focus`, e.g. Draper's next step's
 * `focus=other_way`: that group of videos alone, as if she had pressed "The other way"), and `answer=1` (round 2, C3:
 * the first video waiting for an answer opens; read once, as `focus` is). Plain validators: `validateSearch` ships in
 * the entry chunk, so no zod here.
 */
export interface PastVideoSearch {
  run?: string;
  against?: string;
  video?: string;
  view?: 'points';
  focus?: GroupId;
  answer?: 1;
}

const GROUPS: readonly GroupId[] = ['other_way', 'check', 'same', 'no_verdict', 'to_fix', 'nothing', 'not_yet', 'couldnt'];

const id = (value: unknown): string | undefined => (typeof value === 'string' && /^[\w-]{1,64}$/.test(value) ? value : undefined);

export function parsePastVideoSearch(search: Record<string, unknown>): PastVideoSearch {
  const run = id(search.run);
  const against = id(search.against);
  const video = id(search.video);
  const focus = GROUPS.find((g) => g === search.focus);
  return {
    ...(run ? { run } : {}),
    ...(against && against !== run ? { against } : {}),
    ...(video ? { video } : {}),
    ...(search.view === 'points' ? { view: 'points' as const } : {}),
    ...(focus ? { focus } : {}),
    ...(search.answer === 1 || search.answer === '1' ? { answer: 1 as const } : {}),
  };
}
